import { DComponent } from "../DComponent";

class SectionLoading extends DComponent {

  constructor({
    isFullPage = false,
    parent,
    id,
    variables,
    zIndex,
  } = {}) {
    super(arguments[0], parent, id, variables);
    this.isFullPage = isFullPage;
    this.zIndex = zIndex;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "SectionLoading");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  afterElement() {
    if (this.isFullPage) {
      this.element.addClass("full-page");
    }
    if (this.zIndex) {
      this.element.css("z-index", this.zIndex);
    }
  }

  before() {
    this.parent.css("position", "relative");
  }

  show() {
    if (!this.isLoading()) {
      this.element.addClass("loading");
    }
  }

  hide() {
    this.element.removeClass("loading");
  }

  isLoading() {
    return this.element.hasClass("loading");
  }
}

export default SectionLoading;